"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formControlLabelOverrides = void 0;
var _colorManipulator = require("@mui/system/colorManipulator");
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var formControlLabelOverrides = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: function root(_ref) {
        var _ref$ownerState = _ref.ownerState,
          _ref$ownerState$contr = _ref$ownerState.control,
          checked = _ref$ownerState$contr.props.checked,
          type = _ref$ownerState$contr.type,
          labelPlacement = _ref$ownerState.labelPlacement,
          _ref$ownerState$varia = _ref$ownerState.variant,
          variant = _ref$ownerState$varia === void 0 ? 'default' : _ref$ownerState$varia,
          _ref$theme = _ref.theme,
          palette = _ref$theme.palette,
          shape = _ref$theme.shape,
          spacing = _ref$theme.spacing,
          transitions = _ref$theme.transitions;
        return _objectSpread(_objectSpread(_objectSpread({
          '.MuiCheckbox-root, .MuiRadio-root': {
            marginRight: spacing(1)
          }
        }, (type === _Checkbox.default || type === _Radio.default) && _objectSpread(_objectSpread(_objectSpread({
          marginLeft: -3,
          marginRight: 8
        }, labelPlacement === 'start' && {
          marginLeft: 8,
          // used for row presentation of radio/checkbox
          marginRight: -3
        }), labelPlacement === 'top' && {
          marginLeft: 8
        }), labelPlacement === 'bottom' && {
          marginLeft: 8
        })), variant !== 'default' && {
          margin: 0,
          padding: "".concat(spacing(1), " ").concat(spacing(2)),
          borderRadius: shape.borderRadius,
          transition: transitions.create(['box-shadow'], {
            duration: transitions.duration.shortest,
            easing: transitions.easing.sharp
          }),
          '&:not(.Mui-disabled)': {
            '&:hover': {
              background: palette.grey['50'],
              '.MuiRadio-root, .MuiCheckbox-root': {
                backgroundColor: (0, _colorManipulator.alpha)(palette.grey['1000'], palette.action.hoverOpacity)
              }
            }
          },
          '.MuiFormControlLabel-label': {
            flex: 1,
            '&.Mui-disabled': {
              color: palette.text.disabled
            }
          }
        }), variant === 'outlined' && _objectSpread(_objectSpread(_objectSpread({
          willChange: 'transform',
          boxShadow: palette.action.defaultOutline,
          '&:focus-within': {
            // TODO: focus state needs to be added to figma
            boxShadow: "".concat(palette.action.focusOutline, " ").concat(palette.common.black)
          }
        }, checked && {
          boxShadow: "".concat(palette.action.selectedOutline, " ").concat(palette.common.black)
        }), !checked && {
          '&:hover:not(:focus-within, .Mui-disabled)': {
            boxShadow: "".concat(palette.action.selectableHoverOutline, " ").concat(palette.common.black)
          }
        }), {}, {
          '&.Mui-disabled': {
            boxShadow: "".concat(palette.action.disabledOutline, " ").concat(palette.action.disabledBackground)
          }
        }));
      }
    }
  }
};
exports.formControlLabelOverrides = formControlLabelOverrides;